import loadable from '@loadable/component';

export { default as Text } from './Text';
export { default as Box } from './Box';
export { default as Flex } from './Flex';
export { default as Grid } from './Grid';
export { default as Seo } from './SEO';
export { default as Layout } from './Layout';
export { default as Heading } from './Heading';
export { default as Navbar } from './Navbar';
export { default as Menu } from './Navbar/Menu';
export { default as MobileNavbar } from './Navbar/MobileNavbar';
export { default as PricePlan } from './Plan';
export { Wrapper, Button, Image } from './Styled';
export { StyledTextField } from './StyledTextField';
export {
  Introduction,
  SignupV1,
  SignupV2,
  SignupCountries,
  SignupCountryState,
} from './DeveloperApi/Contents';

export const Header = loadable(() => import('./Header'), { ssr: true });
export const Footer = loadable(() => import('./Footer'), { ssr: false });
export const Hero = loadable(() => import('./Hero'));
export const GatsbyImage = loadable(() => import('./GatsbyImage'));
export const GatsbyBackgroundImage = loadable(() =>
  import('./GatsbyBackgroundImage')
);
export const ImageGrid = loadable(() => import('./ImageGrid'));
export const Highlights = loadable(() => import('./Highlights'));
export const Wallets = loadable(() => import('./Wallets'));
export const SystemStatus = loadable(() => import('./SystemStatus'));
export const Availability = loadable(() => import('./Availability'));
export const InnerHtml = loadable(() => import('./InnerHtml'));
export const Editor = loadable(() => import('./Editor'));
export const Featured = loadable(() => import('./Featured'));
export const Card = loadable(() => import('./Card'));
export const Cards = loadable(() => import('./Cards'));
export const Price = loadable(() => import('./Price'));
export const SocialShare = loadable(() => import('./SocialShare'));
export const Documents = loadable(() => import('./Documents'));
export const ToggleButtons = loadable(() => import('./ToggleButtons'));
export const AtAGlance = loadable(() => import('./AtaGlance'));
export const FeaturesBlock = loadable(() => import('./FeaturesBlock'));
export const ReferralTable = loadable(() => import('./ReferralTable'));
export const OtherPlans = loadable(() => import('./OtherPlans'));
export const ComparePlans = loadable(() => import('./ComparePlans'));
export const DocumentsTable = loadable(() => import('./DocumentsTable'));
export const Travel = loadable(() => import('./Travel'));
export const BlogCard = loadable(() => import('./BlogCard'));
export const BlogLinks = loadable(() => import('./BlogLinks'));
export const SimilarArticles = loadable(() => import('./SimilarArticles'));
export const RangePicker = loadable(() => import('./RangePicker'));
export const RoomOptions = loadable(() => import('./RoomOptions'));
export const DeveloperApi = loadable(() => import('./DeveloperApi'));
export const CustomTable = loadable(() => import('./CustomTable'));
export const CodeBlock = loadable(() => import('./DeveloperApi/CodeBock'));
export const CodeArea = loadable(() => import('./DeveloperApi/CodeArea'));
export const ContentArea = loadable(() => import('./DeveloperApi/ContentArea'));
export const Licences = loadable(() => import('./Licences'));
export const LanguageSwitcher = loadable(() => import('./LanguageSwitcher'));
export const LocationAutocomplete = loadable(() =>
  import('./LocationAutocomplete')
);
